
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/buildings","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc"}},[_c('path',{attrs:{"d":"M13 22.75H5A3.383 3.383 0 011.25 19v-8A3.383 3.383 0 015 7.25h5a.75.75 0 01.75.75v11c0 1.577.673 2.25 2.25 2.25a.75.75 0 010 1.5zm-8-14c-1.577 0-2.25.673-2.25 2.25v8c0 1.577.673 2.25 2.25 2.25h4.8A4.244 4.244 0 019.25 19V8.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7 3.25h3.11a.75.75 0 01.59.293.75.75 0 01.13.65 3.128 3.128 0 00-.08.807v3a.75.75 0 01-.75.75H5A.75.75 0 014.25 8V6A2.753 2.753 0 017 3.25zm2.254 1.5H7A1.251 1.251 0 005.75 6v1.25h3.5V5q0-.129.004-.25zM14 13.75a.75.75 0 01-.75-.75V8a.75.75 0 01.75-.75.75.75 0 01.75.75v5a.75.75 0 01-.75.75zM18 13.75a.75.75 0 01-.75-.75V8a.75.75 0 01.75-.75.75.75 0 01.75.75v5a.75.75 0 01-.75.75z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15 16.25h2A1.752 1.752 0 0118.75 18v4a.75.75 0 01-.75.75h-4a.75.75 0 01-.75-.75v-4A1.752 1.752 0 0115 16.25zm2.25 5V18a.253.253 0 00-.25-.25h-2a.253.253 0 00-.25.25v3.25z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6 17.75a.75.75 0 01-.75-.75v-4a.75.75 0 01.75-.75.75.75 0 01.75.75v4a.75.75 0 01-.75.75z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19 22.75h-6A3.383 3.383 0 019.25 19V5A3.383 3.383 0 0113 1.25h6A3.383 3.383 0 0122.75 5v14A3.383 3.383 0 0119 22.75zm-6-20c-1.577 0-2.25.673-2.25 2.25v14c0 1.577.673 2.25 2.25 2.25h6c1.577 0 2.25-.673 2.25-2.25V5c0-1.577-.673-2.25-2.25-2.25z"}})])])
          )
        }
      }
    